import mqtt from 'mqtt';
import { invokeApig } from './awsLib';
import config from '../config';

const LAST_WILL_TOPIC = 'last-will';
const CLIENT_CONNECTED = 'client-connected';
const CLIENT_DISCONNECTED = 'client-disconnected';

const getNotification = (clientId, userToken) =>
  JSON.stringify({ clientId, userToken });

const validateClientConnected = (client) => {
  if (!client) {
    throw new Error(
      'Client is not connected yet. Call client.connect() first!'
    );
  }
};

export function RealtimeClient(clientId, userToken, topics) {
  let envTopics = [];

  if (topics.length >= 0) {
    for (let i = 0; i < topics.length; i++) {
      envTopics.push(config.ENV + '/' + topics[i]);
    }
  } else {
    envTopics.push(config.ENV + '/' + topics);
  }

  const options = {
    will: {
      topic: LAST_WILL_TOPIC,
      payload: getNotification(clientId, userToken),
    },
  };
  let client = null;

  const clientWrapper = {};
  clientWrapper.connect = () => {
    return invokeApig(
      { service: 'IOT', path: `/iot-presigned-url`, method: 'GET' },
      userToken
    ).then((response) => {
      client = mqtt.connect(response.url, options);
      client.on('connect', () => {
        try {
          for (let i = 0; i < envTopics.length; i++) {
            client.subscribe(envTopics[i]);
          }

          client.subscribe(CLIENT_CONNECTED);
          client.subscribe(CLIENT_DISCONNECTED);
          const connectNotification = getNotification(clientId, userToken);
          client.publish(CLIENT_CONNECTED, connectNotification);
        } catch (e) {
          // do something
        }
      });
      client.on('close', () => {
        client.end();
      });
    });
  };
  clientWrapper.onConnect = (callback) => {
    validateClientConnected(client);
    client.on('connect', callback);
    return clientWrapper;
  };
  clientWrapper.onDisconnect = (callback) => {
    validateClientConnected(client);
    client.on('close', callback);
    return clientWrapper;
  };
  clientWrapper.onMessageReceived = (callback) => {
    validateClientConnected(client);
    client.on('message', (topic, message) => {
      callback(topic, JSON.parse(message.toString('utf8')));
    });
    return clientWrapper;
  };
  clientWrapper.sendMessage = (message) => {
    validateClientConnected(client);

    // todo - wire up if necessary
    // client.publish(messageTopic, JSON.stringify(message))
    // console.log('Sent message: ${MESSAGE_TOPIC} - ${JSON.stringify(message)}')
    return clientWrapper;
  };
  clientWrapper.close = () => {
    if (client !== null) {
      client.end();
    }
  };
  return clientWrapper;
}
